import React from 'react';

export default function Badge({ label = '', brand = '', earlyAccess = false }) {
  return (
    <div className={`branded-product-badge ${earlyAccess ? 'branded-product-badge-early-access' : ''}`} data-product-brand={brand}>{label}</div>
  );
}
